import { render, staticRenderFns } from "./SyncTable.vue?vue&type=template&id=0c4001e0"
import script from "./SyncTable.vue?vue&type=script&lang=ts"
export * from "./SyncTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports